function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.83651613,1.16477419 C9.84425806,0.797806452 9.83032258,0.565935484 9.83032258,0.565935484 L6.24425806,0.563225806 L6.24425806,0.563225806 L6.22606452,0.563225806 L6.20787097,0.563225806 L6.20787097,0.563225806 L2.62141935,0.565935484 C2.62141935,0.565935484 2.60787097,0.797806452 2.6156129,1.16477419 L0.24,1.16477419 L0.24,1.55651613 C0.24,1.64593548 0.255096774,3.75522581 1.55690323,4.91070968 C2.1,5.39264516 2.77741935,5.63496774 3.576,5.63535484 C3.69677419,5.63535484 3.82103226,5.62722581 3.94683871,5.6163871 C4.40051613,6.23767742 4.92464516,6.67277419 5.51419355,6.88954839 L5.51419355,8.61019355 L3.78348387,8.61019355 L3.78348387,9.68787097 L3.21174194,9.68787097 L3.21174194,10.292129 L6.20787097,10.292129 L6.24425806,10.292129 L9.2403871,10.292129 L9.2403871,9.68825806 L8.66825806,9.68825806 L8.66825806,8.61058065 L6.93754839,8.61058065 L6.93754839,6.88993548 C7.52670968,6.67316129 8.05122581,6.23806452 8.50490323,5.61677419 C8.63148387,5.6276129 8.75574194,5.63535484 8.87651613,5.63535484 C9.67470968,5.63458065 10.352129,5.39264516 10.8952258,4.91032258 C12.1970323,3.75483871 12.212129,1.64554839 12.212129,1.55612903 L12.212129,1.16477419 L9.83651613,1.16477419 Z M2.07948387,4.32658065 C1.33587097,3.66851613 1.116,2.54206452 1.05096774,1.94825806 L2.66051613,1.94825806 C2.72864516,2.688 2.88890323,3.60967742 3.25858065,4.41987097 C3.32632258,4.56851613 3.39754839,4.70941935 3.47032258,4.84722581 C2.9156129,4.82593548 2.44877419,4.65290323 2.07948387,4.32658065 Z M10.3726452,4.32658065 C10.0037419,4.65329032 9.53651613,4.82593548 8.98219355,4.84722581 C9.05496774,4.70980645 9.12619355,4.56851613 9.19393548,4.41987097 C9.5636129,3.60967742 9.72387097,2.688 9.7916129,1.94825806 L11.4011613,1.94825806 C11.336129,2.54167742 11.1166452,3.66812903 10.3726452,4.32658065 Z",
  id: "icon_quiz-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Quiz",
  transform: "translate(0.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_quiz",
  transform: "translate(-0.240000, 0.784000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon_quiz-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon_quiz-path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero",
  xlinkHref: "#icon_quiz-path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "UI-Color-/-Active-Color-",
  mask: "url(#icon_quiz-mask-2)",
  fill: "#202020"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-6.000000, -7.000000)",
  id: "Path"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0 24 0 24 24 0 24"
}))))));

function SvgIconQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuiz);
export default __webpack_public_path__ + "static/media/icon_quiz.a8baca1d.svg";
export { ForwardRef as ReactComponent };